<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'Profile' | lang }}</div>
    </header>
    <div>
      <ul class="results arrow">
        <li v-for="(a, idx) in userProfile.profilo.AddressInfo" :key="'addr' + idx" @click="goTo('/account/addresses/' + idx)">
          <div class="title">{{a.FirstName}} {{a.LastName}}</div>
          <div class="subtitle">{{a.TypeOfLane ? a.TypeOfLane.Label : ''}} {{a.Lane}} {{a.NumberOfStreet}} {{a.Town}}</div>
        </li>
        <li>
          <div class="title" @click="goTo('/account/addresses/new')">Add address</div>
          <div class="subtitle">Create a new address</div>
        </li>
      </ul>
    </div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'

export default {
  name: 'AddressPage',
  mixins: [ page ],
  data () {
    return {}
  },
  methods: {
    logout () {
      this.isLogged = false
      this.back()
    }
  },
  beforeDestroy () {},
  mounted () {},
  watch: {}
}
</script>

<style lang="scss">


</style>
